import Path from "../../services/paths";
import DownloadXlxActions from "../actions/downloadXlxActions";
import utils from "../common/utils";
import axios from "axios";
import { generateCoctRobGraphObj } from '../../util-functions/util-funtions'
import CustomToast from '../../util-functions/customToast.jsx'

class DownloadPrimaryXlxMiddleware {
  static downloadXlx(
    primaryDashboard, coctrob
  ) {
    let cotcRob = generateCoctRobGraphObj(primaryDashboard.TotalVolume,
      coctrob)
    let downloadablePrimaryDashboadData = JSON.parse(JSON.stringify(primaryDashboard))
    // for (let value of downloadablePrimaryDashboadData.Seasonality) {
    //   value[Object.keys(value)[0]]['q1'] = value[Object.keys(value)[0]].q1 === 0 ? 0 : Number(value[Object.keys(value)[0]].q1).toFixed(2)
    //   value[Object.keys(value)[0]]['q2'] = value[Object.keys(value)[0]].q2 === 0 ? 0 : Number(value[Object.keys(value)[0]].q2).toFixed(2)
    //   value[Object.keys(value)[0]]['q3'] = value[Object.keys(value)[0]].q3 === 0 ? 0 : Number(value[Object.keys(value)[0]].q2).toFixed(2)
    //   value[Object.keys(value)[0]]['q4'] = value[Object.keys(value)[0]].q4 === 0 ? 0 : Number(value[Object.keys(value)[0]].q4).toFixed(2)
    // }
    // for (let value of downloadablePrimaryDashboadData.Contribution) {
    //   value[Object.keys(value)[0]]['q1'] = value[Object.keys(value)[0]].q1 === 0 ? 0 : Number(value[Object.keys(value)[0]].q1).toFixed(2)
    //   value[Object.keys(value)[0]]['q2'] = value[Object.keys(value)[0]].q2 === 0 ? 0 : Number(value[Object.keys(value)[0]].q2).toFixed(2)
    //   value[Object.keys(value)[0]]['q3'] = value[Object.keys(value)[0]].q3 === 0 ? 0 : Number(value[Object.keys(value)[0]].q2).toFixed(2)
    //   value[Object.keys(value)[0]]['q4'] = value[Object.keys(value)[0]].q4 === 0 ? 0 : Number(value[Object.keys(value)[0]].q4).toFixed(2)

    // }
    // for (let value of downloadablePrimaryDashboadData.GrowthQuater) {
    //   value[Object.keys(value)[0]]['q1'] = value[Object.keys(value)[0]].q1 === 0 ? 0 : Number(value[Object.keys(value)[0]].q1).toFixed(2)
    //   value[Object.keys(value)[0]]['q2'] = value[Object.keys(value)[0]].q2 === 0 ? 0 : Number(value[Object.keys(value)[0]].q2).toFixed(2)
    //   value[Object.keys(value)[0]]['q3'] = value[Object.keys(value)[0]].q3 === 0 ? 0 : Number(value[Object.keys(value)[0]].q2).toFixed(2)
    //   value[Object.keys(value)[0]]['q4'] = value[Object.keys(value)[0]].q4 === 0 ? 0 : Number(value[Object.keys(value)[0]].q4).toFixed(2)

    // }
    // for (let value of downloadablePrimaryDashboadData.HalfContribution) {
    //   value[Object.keys(value)[0]]['h1'] = value[Object.keys(value)[0]].h1 === 0 ? 0 : Number(value[Object.keys(value)[0]].h1).toFixed(2)
    //   value[Object.keys(value)[0]]['h2'] = value[Object.keys(value)[0]].h2 === 0 ? 0 : Number(value[Object.keys(value)[0]].h2).toFixed(2)
    // }
    // for (let value of downloadablePrimaryDashboadData.GrowthTotal) {
    //   value[`${Object.keys(value)[0]}`] = value[Object.keys(value)[0]] === 0 ? 0 : Number(value[Object.keys(value)[0]]).toFixed(2)
    // }
    downloadablePrimaryDashboadData.CoreType[0].ROB.Volume = Number(cotcRob[0].value)
    downloadablePrimaryDashboadData.CoreType[0].ROB.Growth = Number(cotcRob[0].growth)
    downloadablePrimaryDashboadData.CoreType[0].ROB.Contribution = Number(cotcRob[0].contribution)
    downloadablePrimaryDashboadData.CoreType[1].COTC.Volume = Number(cotcRob[1].value)
    downloadablePrimaryDashboadData.CoreType[1].COTC.Growth = Number(cotcRob[1].growth)
    downloadablePrimaryDashboadData.CoreType[1].COTC.Contribution = Number(cotcRob[1].contribution)
    // coctrob.CoreType[0].ROB['Contribution'] = (d.getFullYear() / coctrob.CoreType[0].ROB['Volume']) * 100
    // coctrob.CoreType[1].COtC['Contribution'] = (d.getFullYear() / coctrob.CoreType[1].COTC['Volume']) * 100
    let url = `${Path.POST_DOWNLOAD_PRIMARY_XLX}`;
    return dispatch => {
      dispatch(DownloadXlxActions.downloadXlxRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "POST",
            url: url,
            responseType: 'blob',
            headers: {
              "Content-Type": "application/json",
              // "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              Authorization: `Bearer ${token}`
            },
            data: {
              ...downloadablePrimaryDashboadData
            }
          })
            .then(res => {
              if (res.error) {
              } else {
                let fileName = res.headers['content-disposition'].slice(res.headers['content-disposition'].indexOf('=') + 1,)
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName); //or any other extension
                document.body.appendChild(link);
                link.click();
                // ToastsStore.success("Download Successful")
                CustomToast('success', 'Download Successful')
                dispatch(DownloadXlxActions.downloadXlxSuccessul(res));
              }
            })
            .catch(error => {
              // console.log("IN CATCH");
              // ToastsStore.error("Download Failed!");
              CustomToast('error', 'Download Failed!')
              dispatch(DownloadXlxActions.downloadXlxFailed(error));
            });
        })
        .catch(error => {
          // console.log("IN CATCH");
          dispatch(DownloadXlxActions.downloadXlxFailed(error));
        });
    };
  }
}

export default DownloadPrimaryXlxMiddleware;
